import he from 'he';

// Axios middleware configuration
export default{
    onResponse( response ){
        /** Sanitize HTMLEntities out of group names */
        let decoded = JSON.parse( response.data );
        if( decoded.data ){
            if( Array.isArray( decoded.data ) ){
                decoded.data.forEach( ( group ) => {
                    group.name = he.decode( group.name );
                } );
            }
            else{
                decoded.data.name = he.decode( decoded.data.name );
            }
        }
        response.data = JSON.stringify( decoded );
        return response;
    }
};
